export default __webpack_public_path__ + "static/media/Matter-Regular.f8610025.woff2";